import { createSlice } from "@reduxjs/toolkit";
import axios from "../axios";
import { buildApiV3Url } from "../shared/Utils";

export const customerQuickSearchSlice = createSlice({
    name: "customerQuickSearch",
    initialState: {
        isloading: false,
        data: [],
    },

    reducers: {
        setLoading: (state, action) => {
            state.isloading = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { setLoading, setData } = customerQuickSearchSlice.actions;

export const selectData = state => {
    return state.customerQuickSearch.data;
};

export const selectIsLoading = state => {
    return state.customerQuickSearch.isloading;
};

/**
 * @param {string} value Raw user input.
 * @param {{ top?: number, includeVendors?: boolean, includeAddress?: boolean }} [options]
 * @returns {Promise<Array>} Type-ahead rows from the API.
 */
export const quickSearch = async (value, options = {}) => {
    const { top, includeVendors = false, includeAddress } = options;

    const params = new URLSearchParams();
    params.append("searchString", (value ?? "").trim());
    if (typeof top === "number") params.append("top", String(top));
    params.append("includeVendors", String(includeVendors));
    if (typeof includeAddress === "boolean") {
        params.append("includeAddress", String(includeAddress));
    }
    const queryString = params.toString().replace(/\+/g, "%20");

    const response = await axios.get(buildApiV3Url(`customers/typeahead?${queryString}`), {
        withCredentials: true,
        timeout: 0,
    });
    return response?.data ?? [];
};

/**
 * Exact (case-insensitive) lookup of pasted customer codes or names, for the "Add bulk
 * customers" dialog. Each value is tried as a code and as a name; there is no limit on how
 * many are sent, and every customer a value matches comes back.
 * @param {string[]} values Pasted codes or names, already trimmed and de-duplicated.
 * @param {{ signal?: AbortSignal }} [options] `signal` cancels the request.
 * @returns {Promise<{ matched?: Array, unmatched?: string[] }>} The API's lookup result.
 */
export const bulkCustomerLookup = async (values, { signal } = {}) => {
    const response = await axios.post(
        buildApiV3Url("customers/bulk-customer-lookup"),
        { customerNumbers: values, customerNames: values, includeAddress: true },
        { withCredentials: true, signal }
    );
    return response?.data ?? {};
};

export const clearQuickSearch = () => async dispatch => {
    dispatch(setData([]));
};
export default customerQuickSearchSlice.reducer;
